import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export class WallpaperVideo extends React.PureComponent {
  handleVideoClick = (event) => {
    event.preventDefault();

    const { href } = this.props.creative.meta;
    if (!href) return;

    const link = window.open(href);
    if (link) link.opener = null;
  };

  render() {
    const { src, meta } = this.props.creative;
    const className = classnames('wallpaper__video', {
      'wallpaper--is-clickable': meta.href,
    });

    return (
      <video
        className={className}
        onClick={this.handleVideoClick}
        onKeyPress={this.handleVideoClick}
        src={src}
        autoPlay={true}
        muted={true}
        loop={true}
      />
    );
  }
}

WallpaperVideo.propTypes = {
  creative: PropTypes.object.isRequired,
};

export default WallpaperVideo;
